<div class="site-wrapper">
  <div>
    <app-header />
    <div class="d-flex">
      @if (showSideMenu$ | async) {
        <app-menu />
      }
      <app-main />
    </div>
    <app-footer class="site-footer" />
  </div>
</div>
<ngx-loading-bar [includeSpinner]="false" height="5px" />
